module.exports = __webpack_public_path__ + "img/fan_product-desc1.8c05abfc.png";